// import * as SVG from './esveegee'            // FIXME esbuild / esm?
import { SVG, Cap, Join } from './esveegee'

export const cap = (s: SVG) => {
    s.line(26, 25, 125, 25).width(16).cap(Cap.Butt)
    s.line(26, 65, 125, 65).width(16).cap(Cap.Round)
    s.line(26, 105, 125, 105).width(16).cap(Cap.Square)
}

export const join = (s: SVG) => {
    s.polyline(26, 25, 125, 65).width(16).join(Join.Arcs)
    s.polyline(26, 65, 125, 105).width(16).join(Join.Bevel)
    s.polyline(26, 105, 125, 105).width(16).join(Join.Miter)
    s.polyline(26, 105, 125, 105).width(16).join(Join.MiterClip)
    s.polyline(26, 105, 125, 105).width(16).join(Join.Round)
}

export const miterLimit = (s: SVG) => {
    s.polyline(26, 25, 125, 25).width(16).miterlimit(45)
    s.polyline(26, 65, 125, 65).width(16).miterlimit(10)
}